import styled from "@emotion/styled"
import css from "@styled-system/css"
import Box from "./Box"

// TODO: hardcoded. need to abstract to theme
const Column = styled(Box)`
  ${css({
    px: ["8px", "8px", "10px"],
  })}
`

export default Column
